import { inject, Injectable } from '@angular/core';

import {
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  Observable,
} from 'rxjs';

import { Store } from '@ngrx/store';
import { RouterUrlCurrentService } from '@ts/shared/router/util-url';
import { selectRouteParams } from '@ts/shared/store/data-access-router';

@Injectable({
  providedIn: 'root',
})
export class RouteParamsService {
  private store = inject(Store);
  private routerUrlCurrentService = inject(RouterUrlCurrentService);

  getRouteParamDebounceTimeMs = 100;

  private getRouteParamRaw$(paramName: string): Observable<string | undefined> {
    const routeConfigs = this.routerUrlCurrentService.getRouteConfigs();

    return this.store.select(selectRouteParams).pipe(
      debounceTime(this.getRouteParamDebounceTimeMs),
      filter(() =>
        this.routerUrlCurrentService.isCurrentRouteSamePage(routeConfigs),
      ),
      map((routeParams) => routeParams[paramName]),
    );
  }

  getRouteParam$(paramName: string): Observable<string | undefined> {
    return this.getRouteParamRaw$(paramName).pipe(distinctUntilChanged());
  }

  getRouteParamTruthy$(paramName: string): Observable<string> {
    return this.getRouteParamRaw$(paramName).pipe(
      filter((param) => param !== undefined),
      distinctUntilChanged(),
    );
  }
}
